"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTelemetryTransport = setTelemetryTransport;
exports.getConfiguredTelemetryTransport = getConfiguredTelemetryTransport;
exports.resetTelemetryTransportForTests = resetTelemetryTransportForTests;
const TELEMETRY_TRANSPORT_KEY = Symbol.for("@bestowinc/logger:telemetry-transport");
function isOptionalTransportMethod(value) {
    return value === undefined || typeof value === "function";
}
function isTelemetryTransport(value) {
    if (typeof value !== "object" || value === null) {
        return false;
    }
    const log = Reflect.get(value, "log");
    const noticeError = Reflect.get(value, "noticeError");
    const recordMetric = Reflect.get(value, "recordMetric");
    const captureException = Reflect.get(value, "captureException");
    const getCorrelationMetadata = Reflect.get(value, "getCorrelationMetadata");
    return (typeof log === "function" &&
        typeof noticeError === "function" &&
        isOptionalTransportMethod(recordMetric) &&
        isOptionalTransportMethod(captureException) &&
        isOptionalTransportMethod(getCorrelationMetadata));
}
function setTelemetryTransport(transport) {
    // Store on the browser realm so separately bundled copies resolve the same
    // adapter through Symbol.for without a module-scoped singleton.
    Reflect.set(globalThis, TELEMETRY_TRANSPORT_KEY, transport);
}
function getConfiguredTelemetryTransport() {
    if (!Reflect.has(globalThis, TELEMETRY_TRANSPORT_KEY)) {
        return undefined;
    }
    const value = Reflect.get(globalThis, TELEMETRY_TRANSPORT_KEY);
    if (value === null) {
        return null;
    }
    if (isTelemetryTransport(value)) {
        return value;
    }
    return undefined;
}
function resetTelemetryTransportForTests() {
    Reflect.deleteProperty(globalThis, TELEMETRY_TRANSPORT_KEY);
}
//# sourceMappingURL=telemetry-transport.js.map